import React, { useEffect, useState } from "react";
import { Steps } from "antd";
import svg51 from "../../../assets/svg/svg51.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InvestmentAmount from "./InvestmentAmount";
import PathwayList from "./PathwayList"; 
import BreakDown from "./breakdown/BreakDown";
import SummaryList from "./summary/SummaryList";

function OverviewStepList() {
  const [current, setcurrent] = useState(0);
  const urlSingle = "api/v2/main_projects/get";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, activeObjPlannedProject, dataProjSingle } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      activeObjPlannedProject: state.obj.activeObj["plannedProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    })
  );

  function handleNext() {
    setcurrent(current + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleBack() {
    setcurrent(current - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleReset() {
    setcurrent(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const steps = [
    {
      title: "Investment Amount",
      content: <InvestmentAmount handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
    {
      title: "Pathway",
      content: <PathwayList handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
    {
      title: "Break Down",
      content: <BreakDown handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
  {
      title: "Summary",
      content: <SummaryList handleNext={handleNext} handleBack={handleBack} handleReset={handleReset} />,
      icon: <img src={svg51} alty="svg51" />,
    },


    
  ];

  const items = steps.map((item) => ({
    key: item.key,
    title: item.title,
    icon: item.icon,
  }));

  
  return (
    <>
      <div className="mt-[2.5rem] lg:px-[5rem] px-3">
        <Steps
          className=""
          current={current}
          labelPlacement="vertical"
          items={items}
          onChange={(value) => {
            setcurrent(value);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        />
      </div>
      <div className="mt-[2.12rem] lg:px-0 px-3">{steps[current].content}</div>
    </>
  );
}

export default OverviewStepList;
